import axios from "axios";
import { errorToast } from "../../react-toastfiy/toast";
import { cookieAxios } from "../../interceptors/cookieAxios";

// const excludedURLs = ["/refreshToken", "/login-react"];

// const MT_URL = "https://meratractor.com";
// const MT_URL = "http://192.168.1.13:8001";
// const MT_URL = "http://127.0.0.0:8001";
// const MT_URL = "http://0.0.0.0:8001";
// const MT_URL = "http://192.168.1.8:8003";
// const MT_URL = "http://192.168.72.179:8001";
// const MT_URL = "http://172.20.10.14:8001";
// const MT_URL = "http://192.168.1.8:8001";
// const MT_URL = "http://192.168.1.6:8001";
// const MT_URL = "http://192.168.1.22:8001";
// const MT_URL = "http://192.168.1.22:8001";
// const MT_URL = "https://test.meratractor.com";
// const MT_URL = "https://api.meratractor.com";
// // const MT_URL = "http://localhost:8000";
// // const MT_URL = "http://localhost:8001";

// // const location = useLocation();
// // const asset_id = location.pathname.split(":")[1];

// const cookieAxios = axios.create({
//   baseURL: MT_URL,
//   withCredentials: true,
// });

// const handle401Response = () => {
//   localStorage.clear();
//   window.tokenAboutToExpire = false;
//   window.fetchingRefreshToken = false;
//   window.requestQueue = [];
//   window.location.replace("/sign-in");
// };

// cookieAxios.interceptors.response.use(
//   (resp) => {
//     if (
//       resp?.data?.status === 401 &&
//       !excludedURLs
//         ?.map?.((val) => `${val}`)
//         ?.includes(resp.config?.url)
//     ) {
//       errorToast(resp?.data?.msg);
//       handle401Response();
//       return resp;
//     } else {
//       return resp;
//     }
//   },
//   (error) => {
//     if (
//       error.response?.status === 401 &&
//       excludedURLs
//         ?.map?.((val) => `${val}`)
//         ?.includes(error.config?.url)
//     ) {
//       errorToast(error.response?.data?.msg);
//       handle401Response();
//     }
//     return Promise.reject(error);
//   }
// );

class AuctionService {
  MeratractorLogin = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/login-react`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  LogInByToken = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/user/login-by-token`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  AuctionLogout = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/logout-app-user`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetUserDetailsById = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/user/get-user-details-by-id`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ListAllUsers = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/user/list-all-users`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllApprovalPending = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-auction-approval-pending`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllAssetApprovalPending = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-asset-approval-pending`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ClosedApprovalRequest = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/update-auction-erp-auction-close-request`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateApprovalStatus = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/update-auction-erp-asset-status`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdatePaymentPendingApprovalStatus = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/update-auction-erp-asset-status-from-payment-done`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllPaymentPending = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-auctions-payment-pending`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetUserSegmentPermissionListData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/get-user-segment-permissions-list`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateSegmentPermissions = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-user-segment-permission`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetUserStatePermissionListData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/get-user-permissions-list`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateStatePermissions = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-user-state-permission`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllAssetPaymentPending = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-assets-payment-pending`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAllPaymentsDetails = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-utrlogs-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllFinancierEmailAuctionWise = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-financier-wise-emails`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllCompletedAuction = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-completed-auctions-from-date-range`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  EditChangeClosedRequest = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/edit-change-close-request`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionChangeClosedRequestApprovalPending = async (
    formData,
    source = {},
  ) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-completed-auctions-change-close-request-st`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ClosedRequestApproval = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/update-change-close-request`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetFinancierWiseAuctionList = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/auction-erp-st-dashboard`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetStateWiseFinancierAuctionList = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/auction-erp-admin-dashboard`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetStateWiseFinancierAuctionListCountData = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/auction-erp-admin-dashboard-count-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ApprovedPendingCount = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-auction-approval-pending-count`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  PaymentPendingCount = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-auctions-payment-pending-count`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  BackoutUserCount = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-distinct-backout-users-count`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  AuctionChangeClosedRequestApprovalPendingCount = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-completed-auctions-change-close-request-st-count`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetBackoutApprovalCount = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "get",
      url: `/auctions/get-backout-charges-no-data-count`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetState = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-user-state-permissions`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetSegmentType = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "get",
      url: `/auctions/get-all-segments`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Super segments (2W / 3W / 4W / CV / HCV / Tractor …) — the segment dimension used by
  // Business at a Glance. Normalizes `super_segment_id` to `id` so callers can keep sending
  // `.id` the same way they did with GetSegmentType.
  GetSuperSegmentType = async (formData = new FormData(), source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-super-segments`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        const res = response.data;
        // get-all-super-segments replies with a BARE ARRAY (no {status, data} envelope),
        // unlike get-all-segments. Normalize to the envelope callers expect and expose
        // `id` alongside `super_segment_id` so filter builders can keep sending `.id`.
        const list = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
            ? res.data
            : null;
        if (list) {
          return {
            status: 200,
            data: list.map((s) => ({ ...s, id: s.super_segment_id ?? s.id })),
          };
        }
        return res;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllAuctionReport = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-representative-reports-auctions-listing`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionRepresentativeReportsAssetsListing = async (
    formData,
    source = {},
  ) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-representative-reports-assets-listing`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllAuctionState = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-all-states-open-api`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetUserList = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },

      method: "post",
      url: `/wallet/get_phone_name`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateAuctionSummaryAsset = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/update-auction-summary-asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllAssetForBackoutApprovalPending = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-backout-charges-no-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateBackoutChargesStatus = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/update-backout-charges-status`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionsListBondKYCDownload = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/auction-list-bond-kyc-download`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllAuctionAssetsPaymentPending = async (formData) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-auction-assets-payment-pending`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetListBondKYCDownload = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/asset-list-bond-kyc-download`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionWiseReleaseOrBankNOCPending = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/auction-wise-release-or-banknoc-pending`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetWiseReleaseOrBankNOCPending = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/asset-wise-release-or-banknoc-pending`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ReleaseDoneOfAsset = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/release-done-of-asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  BankNOCDoneOfAsset = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/banknoc-done-of-asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  AuctionWonReports = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/auction-won-report`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ClientCompletedAuctionIDsForERP = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/client/get-completed-auction-ids-for-erp`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetBackoutUserList = async () => {
    return cookieAxios({
      method: "post",
      url: `/user/get-all-blocked-users`,
      // data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetDistinctBackoutUserList = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-distinct-backout-users`,
      data,
      cancelToken: source?.token,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetBackoutChargesDashboard = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-backout-charges-dashboard`,
      data,
      cancelToken: source?.token,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CancelBackout = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/cancel-backout`,
      data,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetChargeUserCases = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-charge-user-cases`,
      data,
      cancelToken: source?.token,
      headers: { "content-type": "application/json" },
    })
      .then((response) => response.data)
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetChargeCollectionSummary = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-charge-collection-summary`,
      data,
      cancelToken: source?.token,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetApprovalChargesDashboard = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-approval-charges-dashboard`,
      data,
      cancelToken: source?.token,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetApprovalChargesSummaryDashboard = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-approval-charges-summary-dashboard`,
      data,
      cancelToken: source?.token,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateApprovalPaymentData = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-approval-payment-data`,
      data,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetDistinctApprovalPaymentPendingUserList = async (data, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-distinct-users-with-approvals`,
      data,
      cancelToken: source?.token,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetUserWiseBackoutList = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-user-wise-backout-data`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetUserWiseApprovalPaymentPendingList = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-approval-payment-data-for-user`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateUserApprovalsPaymentPendingData = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-approval-payment-data`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateBackoutUserStatus = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/user/update-blocked-users`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ClientCompletedAuctionDataForERP = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/client/get-completed-auction-data-for-erp`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionERPAuctionsPaymentPendingCount = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-erp-auctions-payment-pending-count`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetBrandList = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-brand-list`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetFinanciersList = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/api/financiers_erp`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreatAuction = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/add`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  AddBulkAuction = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/add-bulk`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAuction = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/get_auctions`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetARAuction = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get-auction-admin`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  SwitchAuctionData = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/switch/auction`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAssetByAssetId = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/get_auction_details_by_uid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateAssetByAssetId = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/update_auction_by_id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UploadSingleAsset = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/upload_single_asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UploadMultipleAsset = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/upload_multiple_assets`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  RemoveCardAPI = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "POST",
      url: `/auctions/delete/card_one_by_one`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionStatus = async (asset_id, formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/asset-status?uid=${asset_id}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetViewAuctionAssets = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/view/assets_admin`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetViewAuctionAssetsFirebase = async () => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/get/firebase`,
      // data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAuctionSummary = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/auction_summary`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAssetHistory = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-asset-history`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  RefreshNow = async (auction_id, formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/updatelnthighestbid?uid=${auction_id}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAuctionAcr = async (asset_id, formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/acr?uid=${asset_id}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  LockBid = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/lock-bid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UnLockBid = async (formData, source = {}) => {
    return cookieAxios({
      // headers: {
      //   "Content-Type": "application/json",
      // },
      method: "post",
      url: `/auctions/unlock-bids`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAssetPictures = async (uid, formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get_asset_pictures_by_id?ref_no=${uid}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UploadAssetPictures = async (uid, formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/upload_asset_images?uid=${uid}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteAssetPictures = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete/assetImage`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  SetAssetPicturesPrimary = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/view/asset_images`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetBidderNameAndPhone = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/get_phone_name`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateAuctionSummary = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-auction-summary-asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UploadImage = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/upload_asset_excel`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UploadBulkImage = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/upload-bulk-images`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetUserStateList = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/user/api/statelist`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetUserLoginDetails = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/user/get/loginDetails`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UserLogout = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/user/logout/users`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetFinancier = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-financiers`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateFinancier = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-financier`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateFinancier = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-financier`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  SimulateBidding = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/simulate-bidding`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateNoBidBuyer = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/nobid-buyers-create`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateNoBidBuyer = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/nobid-buyers-update`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  NoBidBuyerDetail = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/nobid-buyers-detail`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAllNoBidBuyerList = async () => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/nobid-buyers-list`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  NoBidBuyerDelete = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/nobid-buyers-delete`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAllAPIKeys = async () => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-apikeys`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAPIKeyById = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-apikey-by-id`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateAPIKey = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/create-apikey`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateAPIKey = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-apikey`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteAPIKey = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-apikey`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateUserBackoutData = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-user-backout-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteFinancier = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-financier-by-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetSegments = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-segments-page-wise`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetBackoutReasons = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-backout-reasons`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-segment`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateBackout = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/create-backout-reason`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-segment`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateBackout = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/edit-backout-reason`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-segment-by-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetSegments = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-asset-segments`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateAssetSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-asset-segment`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateAssetSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-asset-segment`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteAssetSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/soft-delete-asset-segment-by-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetSuperSegments = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-super-segments`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateSuperSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-super-segment`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateSuperSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-super-segment`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteSuperSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/soft-delete-super-segment-by-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteBackout = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-backout-reason`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetStateByPageNo = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-all-states-pg-no`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CreateState = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-state`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateState = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-state`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteState = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-state-by-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetBrand = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-brands`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetBrandState = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-brandstates`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAllBrand = async (formData, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/get-all-brands-list`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CreateBrand = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-brand`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  CreateBrandState = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/add-brandstate`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateBrand = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-brand`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateBrandState = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/update-brandstate`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteBrand = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-brand-by-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteBrandState = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete-brandstate-by-brand-and-state-id`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CreateSingleTransaction = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/wallet/single-transaction`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetTransactionByUser = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/view-transactions-by-user`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetMultiTransactionForOneUser = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/upload-transactions-for-one-user`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAllTransaction = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/get-all-transactions`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAllTransactionbyDate = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/get-all-transactions-by-date`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UploadMultipleTransactionExcelFile = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/upload-multiple-transactions`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetLedgerBalanceDetails = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/ledger-balance-details`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetUserListData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/api/userlist`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetStateListData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/api/statelist`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  Permissions = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get/state/permission`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdatePermissions = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/state/permission`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  WalletNotLinked = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/wallet-not-linked-userlist`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  WalletLinked = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/link-wallet`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  AddUserToWallet = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/add-user-to-wallet`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  ExportExcelUserDetails = async (formData, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/wallet/export-excel-user-details`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetImage = async (newAsset, formData, source = {}) => {
    return cookieAxios({
      method: "GET",
      url: `/auctions/get_asset_pictures_by_id?ref_no=${newAsset}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  EditAssetImagePrimary = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/view/asset_images`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  EditAssetImageDelete = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/delete/assetImage`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetSummary = async (newAsset, formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/asset_summary?ref_no=${newAsset}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteBid = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete/bid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DeleteAsset = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete/asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAssetDetails = async (url, formData, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/view/assetbyid?ref_no=${url}`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UpdateAssetDetails = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/edit/asset`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAutoBid = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/view/view_auction_autobid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteAutoBid = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete_user_autobid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  UploadMultipleTransactionForSingleUserHandleExcelofUserDetails = async (
    formData,
    source = {},
  ) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/excel-user-details-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DownloadAllBalanceList = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/ledger-balance-details-download-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionCompletionDetails = async (formData, source = {}) => {
    return axios({
      method: "post",
      url: `/operations/get-auction-completion-state-financier-wise`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionInDateRangeList = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/dashboard/get-auction-in-date-range`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetAuctionUserList = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/dashboard/auction-user-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetWiseBiddingData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/dashboard/asset-wise-bidding-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetMMFSLLotsCount = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/dashboard/get-mmfsl-lots-count`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetMMFSLLotsCountModalData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/dashboard/get-lot-wise-assets`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DownloadACR = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/download-acr`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  DownloadBrandWiseACR = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/download-brand-wise-acr`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetMMFSLLotsImage = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/download-mmfsl-asset-images`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  SendECR = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/send-mmfsl-manual-acr-function`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GetMMFSLLotsCountModal = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/dashboard/get-lot-wise-unique-states`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  RetryACRGeneration = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/regenerate-auction-acr`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  RetryACRBatchWiseApi = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/retry-mmfsl-acr`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  checkMMFSLACRStatusAPI = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-mmfsl-acr-status`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetUserAnalysisData = async (formData, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/dashboard/get-this-month-active-dormant-churn-users`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getExpiredSubAnalysys = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/dashboard/get-expired-subscription-analysis`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  getActiveSubAnalysys = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/dashboard/get-active-subscription-analysis`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  DownloadViewAllTransaction = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/wallet/get-all-transactions-download`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  searchFinancier = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/search-financier-by-name`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  searchSegment = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/search-segment-by-name`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  SearchState = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/search-state-by-name`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  SearchBrand = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/search-brand-by-name`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  SearchPermission = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/api/userlist_search`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CheckBidAmount = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/check-bid-amount`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAuctionAssetAverageBidForERP = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-auction-asset-avg-bid-for-erp`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetNoBiddedAssetsData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-no-bidded-assets-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetNoImageAssetsData = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-no-images-assets-data`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  UploadMultiAssetStartPrice = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-multiple-assets-start-price`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  FetchMetaPortalBids = async (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/fetch-meta-portal-bids`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetAssetPicturesById = (ref_no) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/get_asset_pictures_by_id?ref_no=${ref_no}`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetUserApprovalAnalysisData = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-users-bids-and-approval-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetUserStatePermission = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-user-state-permissions`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetLiveAuction = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-auctions-for-dashboard`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetLiveDashboard = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetLiveDashboardAssetDetail = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-asset-detail`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetLiveDashboardHighBids = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-high-bids`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetLiveDashboardNewUsers = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-new-users`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetLiveDashboardSingleBid = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-single-bid`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetLiveDashboardTopWinners = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-top-winners`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Asset-level export: the server builds the .xlsx and streams it back, so this one
  // asks for a blob rather than JSON. On failure the server still answers with JSON,
  // which the caller detects from the content type.
  GetLiveDashboardAssetExport = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-asset-export`,
      data: formData,
      responseType: "blob",
    }).then((response) => response);
  };

  GetLiveDashboardBidders = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-live-dashboard-bidders`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetLiveAuctionAssetsData = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-auction-assets-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  SetAuctionTarget = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/set-auction-target`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        return error?.response?.data;
      });
  };
  GetAuctionBiddersData = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-auction-bidders-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetApprovalSummaryOfUser = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/approval-summary-of-user`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetAllBankContacts = (formData = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-bankcontacts`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to fetch bank contacts");
      });
  };

  GetAllBrandsList = (formData = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-brands-list`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to fetch brands list");
      });
  };

  GetAllStates = (formData = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-states`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to fetch states list");
      });
  };

  AddBankContact = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/add-bankcontact`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to add bank contact");
      });
  };

  UpdateBankContact = (formData) => {
    return cookieAxios({
      method: "put",
      url: `/auctions/update-bankcontact`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to update bank contact");
      });
  };

  DeleteBankContactById = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete-bankcontact-by-id`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to delete bank contact");
      });
  };

  CheckContactExists = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/check-contact-exists`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to check contact existence");
      });
  };

  GetMultipleAuctionACR = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-multiple-auctions-acr`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to fetch ACRs");
      });
  };

  GetCompletedAuctionAssets = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-completed-auctions-assets`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to fetch ACRs");
      });
  };

  GetMultipleAuctionSummaryData = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-multiple-auctions-summary-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to fetch ACRs");
      });
  };

  RegenerateMultipleAuctionACR = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/regenerate-multiple-auction-acr`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message || "Failed to regenerate ACRs");
      });
  };
  GetBrandUsingUid = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-brand-using-uid`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GeneralAdminAssetSearch = (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/general-admin-asset-search`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // User Vehicle Preference APIs
  GetUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-user-preference`,
      data: formData,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
      });
  };

  // ── Financier & Preference APIs ─────────────────────────────────────────────

  GetAllFinancierErp = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-financiers-erp`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
      });
  };

  GetUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-user-preference`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
      });
  };

  AddUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/create-user-preference`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
        errorToast(e?.message);
      });
  };

  DeleteUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete-user-preference`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
        errorToast(e?.message);
      });
  };

  GetUserFinancierPreferences = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-financier-preferences`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
      });
  };

  AddUserFinancierPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/create-financier-preference`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
        errorToast(e?.message);
      });
  };

  DeleteUserFinancierPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete-financier-preference`,
      data: formData,
    })
      .then((r) => r.data)
      .catch((e) => {
        console.log(e);
        errorToast(e?.message);
      });
  };

  // ─────────────────────────────────────────────────────────────────────────────

  GetSubscribedUsersPreferences = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-subscribed-users-preferences`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAllMakes = async () => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-all-makes`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetModelByMake = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-model-by-make`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Placeholder APIs for future implementation
  AddUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/create-user-preference`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/update-user-preference`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteUserPreference = async (formData) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete-user-preference`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  DeleteOfflineBid = (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/delete-offline-bid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getTargetUserData = (formData, source = {}) => {
    return cookieAxios({
      method: "post",
      url: `/user/get-targets`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Blocked Users APIs
  GetBlockedUsersList = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-blacklisted-users`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ImportBlockedUsers = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/import-blacklisted-users`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  AddBlockedUser = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/create-blacklisted-user`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UnblockUser = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/unblock-blacklisted-user`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetBlockedUsersExcel = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/export-blacklisted-users`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetAssetBidRequestHistory = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/get-asset-bid-request-history`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateUserAddedBy = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/users/update-user-added-by`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateBuyerSegment = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/user/update-buyer-segment`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  BulkEditUsers = async (formData) => {
    return axios({
      method: "POST",
      url: `/users/bulk-edit-users`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getBusinessAtAGlanceData = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/auction-erp-business-at-a-glance-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getBusinessAtAGlanceComparison = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/auction-erp-bag-comparison`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Drill-down list behind the footer "Total" counts (Approved / Fulfilled /
  // Dispute / Default / Unpaid / Payment Pending / TA Applicant) on both
  // BusinessAtAGlance and BusinessAtAGlanceComparison. Same payload shape for
  // both — Comparison additionally sends date_range_type.
  getBusinessAtAGlanceDrilldown = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/auction-erp-bag-drilldown-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getBusinessSpillOverData = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/auction-erp-business-spill-over-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Backend endpoint pending — mirrors getBusinessAtAGlanceComparison's
  // response shape (res.comparisons[key].data.current/previous +
  // .summary.current/previous/delta) but for the Spill Over funnel.
  getBusinessSpillOverComparison = async (formData) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/auction-erp-spill-over-comparison`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // ---------------- Backout relisting console ----------------
  GetRelistings = async (params, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/relisting/list`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetRelistingCounts = async (params, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/relisting/counts`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetRelistingDetail = async (params, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/relisting/detail`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CreateRelisting = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/create`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  UpdateRelisting = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/update`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  EndRelisting = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/end`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // bid_id of a bid on a live or awaiting-approval listing; ABO/ASA only
  DeleteRelistingBid = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/delete-bid`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // bid_id, or settle='none'
  ApproveRelistingBid = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/approve`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  SetRelistingVisibility = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/visibility`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  SetRelistingPin = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/relisting/pin`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Payment comments (Payment Pending board) — add and read only
  GetPaymentComments = async (params, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/payment-comments/list`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  // Payment maker-checker. Approval goes through UpdateApprovalStatus with submission_id.
  CreatePaymentSubmission = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/payment-submissions/create`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  RejectPaymentSubmission = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/payment-submissions/reject`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetPaymentSubmissionHistory = async (params, source = {}) => {
    return cookieAxios({
      method: "get",
      url: `/auctions/payment-submissions/history`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CreatePaymentComment = async (formData, source = {}) => {
    return cookieAxios({
      method: "POST",
      url: `/auctions/payment-comments/create`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
}
export default new AuctionService();
